export default class ListingFilter {
    constructor() {
        this.filtersContainer = document.querySelector(".nav-filter");

        if (this.filtersContainer) {
            this.initFilters();
        }
    }

    initFilters() {
        let url = this.filtersContainer.dataset.postTypePath;
        if (! url) {
            return;
        }

        const btnFilter = this.filtersContainer.querySelector(".nav-filter-button");
        const selects = this.filtersContainer.querySelectorAll(".nav-filter-select");

        btnFilter.addEventListener("click", (e) => {
            e.preventDefault();

            const params = new URLSearchParams();

            selects.forEach((select) => {
                const type = select.getAttribute("id");
                if (select.value) {
                    params.append(type, select.value);
                }
            });

            const queryString = params.toString();

            if (queryString) {
                url += "?" + queryString;
            }

            window.location.href = url;
        });
    }
}